<template>
  <div class="segment">
    <div class="controller">
      <!-- 滑块 -->
      <div class="slider" :style="sliderStyle"></div>

      <!-- 选项 -->
      <div
        v-for="(item, index) in formatOptions"
        :key="item.value"
        class="item"
        :style="{ color: index === activeIndex ? '#000' : '#4e5969' }"
        @click="handleClick(item, index)"
        ref="items"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SegmentController",
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      activeIndex: this.options.findIndex((option) => option.value === this.value), // 计算当前选中索引
      itemWidth: 0, // 记录每个选项的宽度
    };
  },
  computed: {
    formatOptions() {
      return this.options.map((option) => ({
        value: option.value,
        label: option.label,
      }));
    },
    // 计算滑块的样式
    sliderStyle() {
      return {
        width: `${this.itemWidth}px`, // 滑块宽度与选项一致
        transform: `translateX(${this.activeIndex * this.itemWidth}px)`, // 滑块位置
        transition: 'transform 0.3s ease-in-out', // 平滑过渡
      };
    },
  },
  watch: {
    value(newVal) {
      this.activeIndex = this.options.findIndex((option) => option.value === newVal);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateItemWidth();
    });
  },
  methods: {
    handleClick(item, index) {
      this.activeIndex = index; // 更新索引
      this.$emit("change", item.value);
    },
    // 获取选项宽度
    updateItemWidth() {
      const item = this.$refs.items[0]; // 获取第一个选项
      if (item) {
        this.itemWidth = item.offsetWidth; // 获取选项宽度
      }
    },
  },
};
</script>

<style scoped lang="scss">
.segment {
  display: flex;
  justify-content: center;
  width: 100%;

  .controller {
    position: relative;
    display: flex;
    align-items: center;
    background: #e6e8eb;
    border-radius: 5px;
    font-weight: 400;
    font-size: 12px;
    color: #4e5969;
    cursor: pointer;
    border: 2px solid #e6e8eb;
    overflow: hidden; // 防止滑块溢出
  }

  // 滑块样式
  .slider {
    position: absolute;
    height: 100%;
    background: #fff;
    border-radius: 5px;
  }

  .item {
    text-align: center;
    padding: 8px 12px; /* 控制左右内边距 */
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap;
    cursor: pointer;
    z-index: 1; // 让文字不被滑块遮挡
    transition: color 0.3s ease-in-out; // 文字颜色平滑过渡
    min-width: 60px;  /* 设置最小宽度 */
    flex-shrink: 0;   /* 防止压缩，保证宽度一致 */
  }
}
</style>
